export const translations = {
    en: {
        'Language': 'Language',
        'English': 'English',
        'Italian': 'Italian',
        'Spanish': 'Spanish',
        'Dashboard': 'Dashboard',
        'Tokens': 'Tokens',
        'Invoices': 'Invoices',
        'Product creation': 'Product creation',
        'Navigation Menu': 'Navigation Menu',
        'Sidebar': 'Sidebar',
        'Displays the mobile sidebar.': 'Displays the mobile sidebar.',
        'Toggle Sidebar': 'Toggle Sidebar',
        'More': 'More',
        'Search': 'Search',
        'Platform': 'Platform',
        'Log out': 'Log out',
        'Profile': 'Profile',
        'Password': 'Password',
        'Two-Factor Auth': 'Two-Factor Auth',
        'Appearance': 'Appearance',
        'Settings': 'Settings',
        'Manage your profile and account settings': 'Manage your profile and account settings',
        'Profile settings': 'Profile settings',
        'Profile information': 'Profile information',
        'Update your name and email address': 'Update your name and email address',
        'Name': 'Name',
        'Full name': 'Full name',
        'Email address': 'Email address',
        'Your email address is unverified.': 'Your email address is unverified.',
        'Click here to resend the verification email.': 'Click here to resend the verification email.',
        'A new verification link has been sent to your email address.':
            'A new verification link has been sent to your email address.',
        'Save': 'Save',
        'Saved': 'Saved',
        'Delete account': 'Delete account',
        'Delete your account and all of its resources': 'Delete your account and all of its resources',
        'Warning': 'Warning',
        'Please proceed with caution, this cannot be undone.':
            'Please proceed with caution, this cannot be undone.',
        'Are you sure you want to delete your account?':
            'Are you sure you want to delete your account?',
        'Once your account is deleted, all of its resources and data will also be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.':
            'Once your account is deleted, all of its resources and data will also be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.',
        'Cancel': 'Cancel',
        'Password settings': 'Password settings',
        'Update password': 'Update password',
        'Ensure your account is using a long, random password to stay secure':
            'Ensure your account is using a long, random password to stay secure',
        'Current password': 'Current password',
        'New password': 'New password',
        'Confirm password': 'Confirm password',
        'Save password': 'Save password',
        'Appearance settings': 'Appearance settings',
        "Update your account's appearance settings":
            "Update your account's appearance settings",
        'Light': 'Light',
        'Dark': 'Dark',
        'System': 'System',
        'Toggle theme': 'Toggle theme',
        'Two-Factor Authentication': 'Two-Factor Authentication',
        'Manage your two-factor authentication settings':
            'Manage your two-factor authentication settings',
        'Enabled': 'Enabled',
        'Disabled': 'Disabled',
        'With two-factor authentication enabled, you will be prompted for a secure, random pin during login, which you can retrieve from the TOTP-supported application on your phone.':
            'With two-factor authentication enabled, you will be prompted for a secure, random pin during login, which you can retrieve from the TOTP-supported application on your phone.',
        'Disable 2FA': 'Disable 2FA',
        'When you enable two-factor authentication, you will be prompted for a secure pin during login. This pin can be retrieved from a TOTP-supported application on your phone.':
            'When you enable two-factor authentication, you will be prompted for a secure pin during login. This pin can be retrieved from a TOTP-supported application on your phone.',
        'Continue Setup': 'Continue Setup',
        'Enable 2FA': 'Enable 2FA',
        '2FA Recovery Codes': '2FA Recovery Codes',
        'Recovery codes let you regain access if you lose your 2FA device. Store them in a secure password manager.':
            'Recovery codes let you regain access if you lose your 2FA device. Store them in a secure password manager.',
        'Hide': 'Hide',
        'View': 'View',
        'Recovery Codes': 'Recovery Codes',
        'Regenerate Codes': 'Regenerate Codes',
        'Recovery codes': 'Recovery codes',
        'Loading recovery codes': 'Loading recovery codes',
        'Each recovery code can be used once to access your account and will be removed after use. If you need more, click {action} above.':
            'Each recovery code can be used once to access your account and will be removed after use. If you need more, click {action} above.',
        'Something went wrong.': 'Something went wrong.',
        'Token balance': 'Token balance',
        'Purchase tokens once and use them across any feature you need.':
            'Purchase tokens once and use them across any feature you need.',
        'Available tokens': 'Available tokens',
        'Spend tokens wherever you need them across the app.':
            'Spend tokens wherever you need them across the app.',
        'Payment canceled': 'Payment canceled',
        'Success': 'Success',
        '{count} tokens': '{count} tokens',
        '/ pack': '/ pack',
        'Tokens are universal and can be spent on any feature—image generation, text polishing, or future creative tools. You can purchase multiple packs at checkout.':
            'Tokens are universal and can be spent on any feature—image generation, text polishing, or future creative tools. You can purchase multiple packs at checkout.',
        'Billing currency: {currency}': 'Billing currency: {currency}',
        'Pack quantity': 'Pack quantity',
        'Starting checkout...': 'Starting checkout...',
        'Buy tokens': 'Buy tokens',
        'Configure price ID': 'Configure price ID',
        'Invoice history': 'Invoice history',
        'Your most recent Stripe invoices and receipts.':
            'Your most recent Stripe invoices and receipts.',
        'Review and download receipts for your token purchases.':
            'Review and download receipts for your token purchases.',
        '{count} total': '{count} total',
        'No invoices found yet. Purchases will appear here once completed.':
            'No invoices found yet. Purchases will appear here once completed.',
        'Invoice #{number}': 'Invoice #{number}',
        'paid': 'paid',
        'open': 'open',
        'draft': 'draft',
        'View invoice': 'View invoice',
        'Log in to your account': 'Log in to your account',
        'Enter your email and password below to log in':
            'Enter your email and password below to log in',
        'Log in': 'Log in',
        'Forgot password?': 'Forgot password?',
        'Forgot password': 'Forgot password',
        'Enter your email to receive a password reset link':
            'Enter your email to receive a password reset link',
        'Remember me': 'Remember me',
        "Don't have an account?": "Don't have an account?",
        'Sign up': 'Sign up',
        'Create an account': 'Create an account',
        'Enter your details below to create your account':
            'Enter your details below to create your account',
        'Already have an account?': 'Already have an account?',
        'Register': 'Register',
        'Forgot your password?': 'Forgot your password?',
        'No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.':
            'No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.',
        'Email password reset link': 'Email password reset link',
        'Or, return to': 'Or, return to',
        'Back to log in': 'Back to log in',
        'Reset password': 'Reset password',
        'Please enter your new password below':
            'Please enter your new password below',
        'Confirm your password': 'Confirm your password',
        'This is a secure area of the application. Please confirm your password before continuing.':
            'This is a secure area of the application. Please confirm your password before continuing.',
        'Confirm': 'Confirm',
        'Continue': 'Continue',
        'Authentication Code': 'Authentication Code',
        'or you can': 'or you can',
        'or, enter the code manually': 'or, enter the code manually',
        'Back': 'Back',
        'Close': 'Close',
        'Two-Factor Authentication Enabled':
            'Two-Factor Authentication Enabled',
        'Two-factor authentication is now enabled. Scan the QR code or enter the setup key in your authenticator app.':
            'Two-factor authentication is now enabled. Scan the QR code or enter the setup key in your authenticator app.',
        'Verify Authentication Code': 'Verify Authentication Code',
        'Enter the 6-digit code from your authenticator app':
            'Enter the 6-digit code from your authenticator app',
        'Enable Two-Factor Authentication': 'Enable Two-Factor Authentication',
        'To finish enabling two-factor authentication, scan the QR code or enter the setup key in your authenticator app':
            'To finish enabling two-factor authentication, scan the QR code or enter the setup key in your authenticator app',
        'Two factor challenge': 'Two factor challenge',
        'Please confirm access to your account by entering the authentication code provided by your authenticator application.':
            'Please confirm access to your account by entering the authentication code provided by your authenticator application.',
        'Please confirm access to your account by entering one of your emergency recovery codes.':
            'Please confirm access to your account by entering one of your emergency recovery codes.',
        'Code': 'Code',
        'Recovery code': 'Recovery code',
        'Use a recovery code': 'Use a recovery code',
        'Use an authentication code': 'Use an authentication code',
        'Verify email': 'Verify email',
        'Please verify your email address by clicking on the link we just emailed to you.':
            'Please verify your email address by clicking on the link we just emailed to you.',
        'Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you did not receive the email, we will gladly send you another.':
            'Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you did not receive the email, we will gladly send you another.',
        'A new verification link has been sent to the email address you provided during registration.':
            'A new verification link has been sent to the email address you provided during registration.',
        'Resend verification email': 'Resend verification email',
        'Welcome': 'Welcome',
        "Let's get started": "Let's get started",
        'Laravel has an incredibly rich ecosystem. We suggest starting with the following.':
            'Laravel has an incredibly rich ecosystem. We suggest starting with the following.',
        'Read the': 'Read the',
        'Documentation': 'Documentation',
        'Watch video tutorials at': 'Watch video tutorials at',
        'Deploy now': 'Deploy now',
        'Modifica il codice EAN o continua': 'Edit the EAN code or continue',
        'Crea la scheda prodotto per il tuo catalogo':
            'Create the product sheet for your catalog',
        'EAN': 'EAN',
        'Brand': 'Brand',
        'Prodotto salvato': 'Product saved',
        'Il prodotto è stato salvato nelle bozze del tuo catalogo.':
            'The product has been saved to your catalog drafts.',
        'Inserisci codice EAN (13 cifre)': 'Enter EAN code (13 digits)',
        'Valido': 'Valid',
        'Non valido': 'Invalid',
        'Nuovo Prodotto': 'New product',
        'Nuovo prodotto': 'New product',
        'Verifica in corso...': 'Checking...',
        'Verifica GS1': 'Check GS1',
        'Continua': 'Continue',
        'Inserisci il codice EAN a 13 cifre del prodotto per verificarne la validità':
            'Enter the 13-digit EAN code to verify its validity',
        'Chiudi': 'Close',
        'Salvare questo prodotto?': 'Save this product?',
        'Vuoi salvare questo prodotto nel tuo catalogo in bozze per completarlo successivamente o vuoi eliminarlo?':
            'Do you want to save this product as a draft to finish later, or delete it?',
        'Salva in Bozze': 'Save as draft',
        'Elimina Prodotto': 'Delete product',
        'EAN:': 'EAN:',
        "Qual'è il brand del prodotto?": "What's the product brand?",
        'Inserisci il nome del marchio': 'Enter the brand name',
        'Es. Apple, Samsung, Nike...': 'e.g. Apple, Samsung, Nike...',
        'Nota bene:': 'Note:',
        'scrivere come visibile sulla confezione o, se presente, nella registrazione ufficiale del marchio, rispettando maiuscole e minuscole.':
            'write it as shown on the packaging or, if available, in the official brand registration, respecting uppercase and lowercase letters.',
        'Indietro': 'Back',
        'Step {current} di {total}': 'Step {current} of {total}',
        'Immagine': 'Image',
        'Titolo': 'Title',
        'Tipologia': 'Type',
        'Categoria': 'Category',
        'Contenuti': 'Content',
        'Dimensioni': 'Dimensions',
        'Prezzo/Stock/T.c.': 'Price/Stock/Lead time',
        'Info Generali': 'General info',
        'Immagini': 'Images',
        'First name': 'First name',
        'Last name': 'Last name',
        'User info': 'User info',
        'Company info': 'Company info',
        'Company name': 'Company name',
        'VAT ID': 'VAT ID',
        'Admin name': 'Admin name',
        'Province': 'Province',
        'Country': 'Country',
        'Company email': 'Company email',
        'Create password': 'Create password',
        'Password strength: weak': 'Password strength: weak',
        'Password strength: medium': 'Password strength: medium',
        'Password strength: strong': 'Password strength: strong',
        'At least 8 characters': 'At least 8 characters',
        'At least one uppercase': 'At least one uppercase letter',
        'At least one lowercase': 'At least one lowercase letter',
        'At least one number': 'At least one number',
        'At least one special char': 'At least one special character',
        'Passwords match': 'Passwords match',
        'I accept': 'I accept',
        'Terms and conditions': 'Terms and conditions',
        'and the': 'and the',
        'Privacy policy': 'Privacy policy',
        'Invalid email': 'Invalid email',
        'Address': 'Address',
        'City': 'City',
        'Postal code': 'Postal code',
        'Phone': 'Phone',
    },
    it: {
        'Language': 'Lingua',
        'English': 'Inglese',
        'Italian': 'Italiano',
        'Spanish': 'Spagnolo',
        'Dashboard': 'Dashboard',
        'Tokens': 'Token',
        'Invoices': 'Fatture',
        'Product creation': 'Creazione prodotto',
        'Navigation Menu': 'Menu di navigazione',
        'Sidebar': 'Barra laterale',
        'Displays the mobile sidebar.': 'Mostra la barra laterale mobile.',
        'Toggle Sidebar': 'Apri/chiudi barra laterale',
        'More': 'Altro',
        'Search': 'Cerca',
        'Platform': 'Piattaforma',
        'Settings': 'Impostazioni',
        'Log out': 'Esci',
        'Profile': 'Profilo',
        'Password': 'Password',
        'Two-Factor Auth': 'Autenticazione a due fattori',
        'Appearance': 'Aspetto',
        'Manage your profile and account settings':
            'Gestisci le impostazioni del profilo e dell’account',
        'Profile settings': 'Impostazioni profilo',
        'Profile information': 'Informazioni profilo',
        'Update your name and email address':
            'Aggiorna il tuo nome e indirizzo email',
        'Name': 'Nome',
        'Full name': 'Nome completo',
        'Email address': 'Indirizzo email',
        'Your email address is unverified.':
            'Il tuo indirizzo email non è verificato.',
        'Click here to resend the verification email.':
            "Clicca qui per inviare nuovamente l'email di verifica.",
        'A new verification link has been sent to your email address.':
            'Un nuovo link di verifica è stato inviato al tuo indirizzo email.',
        'Save': 'Salva',
        'Saved': 'Salvato',
        'Delete account': 'Elimina account',
        'Delete your account and all of its resources':
            'Elimina il tuo account e tutte le sue risorse',
        'Warning': 'Attenzione',
        'Please proceed with caution, this cannot be undone.':
            'Procedi con cautela, questa operazione non può essere annullata.',
        'Are you sure you want to delete your account?':
            'Sei sicuro di voler eliminare il tuo account?',
        'Once your account is deleted, all of its resources and data will also be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.':
            "Una volta eliminato l'account, tutte le risorse e i dati saranno cancellati in modo permanente. Inserisci la password per confermare.",
        'Cancel': 'Annulla',
        'Password settings': 'Impostazioni password',
        'Update password': 'Aggiorna password',
        'Ensure your account is using a long, random password to stay secure':
            'Assicurati che il tuo account utilizzi una password lunga e casuale per restare al sicuro',
        'Current password': 'Password attuale',
        'New password': 'Nuova password',
        'Confirm password': 'Conferma password',
        'Save password': 'Salva password',
        'Appearance settings': 'Impostazioni aspetto',
        "Update your account's appearance settings":
            "Aggiorna le impostazioni di aspetto dell'account",
        'Light': 'Chiaro',
        'Dark': 'Scuro',
        'System': 'Sistema',
        'Toggle theme': 'Cambia tema',
        'Two-Factor Authentication': 'Autenticazione a due fattori',
        'Manage your two-factor authentication settings':
            "Gestisci le impostazioni dell'autenticazione a due fattori",
        'Enabled': 'Abilitata',
        'Disabled': 'Disabilitata',
        'With two-factor authentication enabled, you will be prompted for a secure, random pin during login, which you can retrieve from the TOTP-supported application on your phone.':
            'Con l’autenticazione a due fattori abilitata, al login ti verrà richiesto un PIN sicuro che potrai recuperare dall’app TOTP sul tuo telefono.',
        'Disable 2FA': 'Disabilita 2FA',
        'When you enable two-factor authentication, you will be prompted for a secure pin during login. This pin can be retrieved from a TOTP-supported application on your phone.':
            'Quando abiliti l’autenticazione a due fattori, al login ti verrà richiesto un PIN sicuro recuperabile dall’app TOTP sul tuo telefono.',
        'Continue Setup': 'Continua configurazione',
        'Enable 2FA': 'Abilita 2FA',
        '2FA Recovery Codes': 'Codici di recupero 2FA',
        'Recovery codes let you regain access if you lose your 2FA device. Store them in a secure password manager.':
            'I codici di recupero ti permettono di accedere se perdi il dispositivo 2FA. Conservali in un password manager.',
        'Hide': 'Nascondi',
        'View': 'Mostra',
        'Recovery Codes': 'Codici di recupero',
        'Regenerate Codes': 'Rigenera codici',
        'Recovery codes': 'Codici di recupero',
        'Loading recovery codes': 'Caricamento codici di recupero',
        'Each recovery code can be used once to access your account and will be removed after use. If you need more, click {action} above.':
            'Ogni codice di recupero può essere usato una sola volta e verrà rimosso dopo l’uso. Se ne hai bisogno, clicca {action} sopra.',
        'Something went wrong.': 'Qualcosa è andato storto.',
        'Token balance': 'Saldo token',
        'Purchase tokens once and use them across any feature you need.':
            'Acquista token una volta e usali per qualsiasi funzionalità.',
        'Available tokens': 'Token disponibili',
        'Spend tokens wherever you need them across the app.':
            "Spendi i token dove vuoi all'interno dell'app.",
        'Payment canceled': 'Pagamento annullato',
        'Success': 'Operazione riuscita',
        '{count} tokens': '{count} token',
        '/ pack': '/ pacchetto',
        'Tokens are universal and can be spent on any feature—image generation, text polishing, or future creative tools. You can purchase multiple packs at checkout.':
            'I token sono universali e possono essere spesi per qualsiasi funzionalità: generazione immagini, revisione testo o strumenti futuri. Puoi acquistare più pacchetti al checkout.',
        'Billing currency: {currency}': 'Valuta di fatturazione: {currency}',
        'Pack quantity': 'Quantità pacchetto',
        'Starting checkout...': 'Avvio checkout...',
        'Buy tokens': 'Acquista token',
        'Configure price ID': 'Configura ID prezzo',
        'Invoice history': 'Storico fatture',
        'Your most recent Stripe invoices and receipts.':
            'Le tue fatture e ricevute Stripe più recenti.',
        'Review and download receipts for your token purchases.':
            'Consulta e scarica le ricevute per i tuoi acquisti di token.',
        '{count} total': '{count} totali',
        'No invoices found yet. Purchases will appear here once completed.':
            'Nessuna fattura trovata. Gli acquisti appariranno qui una volta completati.',
        'Invoice #{number}': 'Fattura n. {number}',
        'paid': 'pagata',
        'open': 'aperta',
        'draft': 'bozza',
        'View invoice': 'Visualizza fattura',
        'Log in to your account': 'Accedi al tuo account',
        'Enter your email and password below to log in':
            'Inserisci email e password per accedere',
        'Log in': 'Accedi',
        'Forgot password?': 'Password dimenticata?',
        'Forgot password': 'Password dimenticata',
        'Enter your email to receive a password reset link':
            'Inserisci la tua email per ricevere un link di reset password',
        'Remember me': 'Ricordami',
        "Don't have an account?": 'Non hai un account?',
        'Sign up': 'Registrati',
        'Create an account': 'Crea un account',
        'Enter your details below to create your account':
            'Inserisci i tuoi dati per creare un account',
        'Already have an account?': 'Hai già un account?',
        'Register': 'Registrati',
        'Forgot your password?': 'Hai dimenticato la password?',
        'No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.':
            'Nessun problema. Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.',
        'Email password reset link': 'Invia link di reset password',
        'Or, return to': 'Oppure torna a',
        'Back to log in': 'Torna al login',
        'Reset password': 'Reimposta password',
        'Please enter your new password below':
            'Inserisci di seguito la tua nuova password',
        'Confirm your password': 'Conferma la password',
        'This is a secure area of the application. Please confirm your password before continuing.':
            'Questa è un’area sicura dell’applicazione. Conferma la password per continuare.',
        'Confirm': 'Conferma',
        'Continue': 'Continua',
        'Authentication Code': 'Codice di autenticazione',
        'or you can': 'oppure puoi',
        'or, enter the code manually': 'oppure inserisci il codice manualmente',
        'Back': 'Indietro',
        'Close': 'Chiudi',
        'Two-Factor Authentication Enabled':
            'Autenticazione a due fattori abilitata',
        'Two-factor authentication is now enabled. Scan the QR code or enter the setup key in your authenticator app.':
            'L’autenticazione a due fattori è ora abilitata. Scansiona il QR o inserisci la chiave nella tua app.',
        'Verify Authentication Code': 'Verifica codice di autenticazione',
        'Enter the 6-digit code from your authenticator app':
            'Inserisci il codice a 6 cifre dalla tua app di autenticazione',
        'Enable Two-Factor Authentication':
            'Abilita autenticazione a due fattori',
        'To finish enabling two-factor authentication, scan the QR code or enter the setup key in your authenticator app':
            'Per completare l’abilitazione, scansiona il QR o inserisci la chiave nella tua app.',
        'Two factor challenge': 'Verifica a due fattori',
        'Please confirm access to your account by entering the authentication code provided by your authenticator application.':
            'Conferma l’accesso inserendo il codice dell’app di autenticazione.',
        'Please confirm access to your account by entering one of your emergency recovery codes.':
            'Conferma l’accesso inserendo uno dei codici di recupero di emergenza.',
        'Code': 'Codice',
        'Recovery code': 'Codice di recupero',
        'Use a recovery code': 'Usa un codice di recupero',
        'Use an authentication code': 'Usa un codice di autenticazione',
        'Verify email': 'Verifica email',
        'Please verify your email address by clicking on the link we just emailed to you.':
            'Verifica la tua email cliccando sul link che ti abbiamo appena inviato.',
        'Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you did not receive the email, we will gladly send you another.':
            'Grazie per esserti registrato! Prima di iniziare, verifica la tua email cliccando sul link che ti abbiamo inviato. Se non hai ricevuto l’email, te ne invieremo un’altra.',
        'A new verification link has been sent to the email address you provided during registration.':
            'Un nuovo link di verifica è stato inviato all’indirizzo email fornito in fase di registrazione.',
        'Resend verification email': 'Reinvia email di verifica',
        'Welcome': 'Benvenuto',
        "Let's get started": 'Iniziamo',
        'Laravel has an incredibly rich ecosystem. We suggest starting with the following.':
            'Laravel ha un ecosistema ricchissimo. Ti consigliamo di iniziare con quanto segue.',
        'Read the': 'Leggi la',
        'Documentation': 'Documentazione',
        'Watch video tutorials at': 'Guarda i video tutorial su',
        'Deploy now': 'Distribuisci ora',
        'Modifica il codice EAN o continua': 'Modifica il codice EAN o continua',
        'Crea la scheda prodotto per il tuo catalogo':
            'Crea la scheda prodotto per il tuo catalogo',
        'EAN': 'EAN',
        'Brand': 'Brand',
        'Prodotto salvato': 'Prodotto salvato',
        'Il prodotto è stato salvato nelle bozze del tuo catalogo.':
            'Il prodotto è stato salvato nelle bozze del tuo catalogo.',
        'Inserisci codice EAN (13 cifre)': 'Inserisci codice EAN (13 cifre)',
        'Valido': 'Valido',
        'Non valido': 'Non valido',
        'Nuovo Prodotto': 'Nuovo Prodotto',
        'Nuovo prodotto': 'Nuovo prodotto',
        'Verifica in corso...': 'Verifica in corso...',
        'Verifica GS1': 'Verifica GS1',
        'Continua': 'Continua',
        'Inserisci il codice EAN a 13 cifre del prodotto per verificarne la validità':
            'Inserisci il codice EAN a 13 cifre del prodotto per verificarne la validità',
        'Chiudi': 'Chiudi',
        'Salvare questo prodotto?': 'Salvare questo prodotto?',
        'Vuoi salvare questo prodotto nel tuo catalogo in bozze per completarlo successivamente o vuoi eliminarlo?':
            'Vuoi salvare questo prodotto nel tuo catalogo in bozze per completarlo successivamente o vuoi eliminarlo?',
        'Salva in Bozze': 'Salva in Bozze',
        'Elimina Prodotto': 'Elimina Prodotto',
        'EAN:': 'EAN:',
        "Qual'è il brand del prodotto?": "Qual'è il brand del prodotto?",
        'Inserisci il nome del marchio': 'Inserisci il nome del marchio',
        'Es. Apple, Samsung, Nike...': 'Es. Apple, Samsung, Nike...',
        'Nota bene:': 'Nota bene:',
        'scrivere come visibile sulla confezione o, se presente, nella registrazione ufficiale del marchio, rispettando maiuscole e minuscole.':
            'scrivere come visibile sulla confezione o, se presente, nella registrazione ufficiale del marchio, rispettando maiuscole e minuscole.',
        'Indietro': 'Indietro',
        'Step {current} di {total}': 'Step {current} di {total}',
        'Immagine': 'Immagine',
        'Titolo': 'Titolo',
        'Tipologia': 'Tipologia',
        'Categoria': 'Categoria',
        'Contenuti': 'Contenuti',
        'Dimensioni': 'Dimensioni',
        'Prezzo/Stock/T.c.': 'Prezzo/Stock/T.c.',
        'Info Generali': 'Info Generali',
        'Immagini': 'Immagini',
        'First name': 'Nome',
        'Last name': 'Cognome',
        'User info': 'Informazioni utente',
        'Company info': 'Informazioni azienda',
        'Company name': 'Nome azienda',
        'VAT ID': 'Partita IVA',
        'Admin name': 'Nome amministratore',
        'Province': 'Provincia',
        'Country': 'Paese',
        'Company email': 'Email aziendale',
        'Create password': 'Crea password',
        'Password strength: weak': 'Sicurezza password: debole',
        'Password strength: medium': 'Sicurezza password: media',
        'Password strength: strong': 'Sicurezza password: forte',
        'At least 8 characters': 'Almeno 8 caratteri',
        'At least one uppercase': 'Almeno una lettera maiuscola',
        'At least one lowercase': 'Almeno una lettera minuscola',
        'At least one number': 'Almeno un numero',
        'At least one special char': 'Almeno un carattere speciale',
        'Passwords match': 'Le password coincidono',
        'I accept': 'Accetto',
        'Terms and conditions': 'Termini e condizioni',
        'and the': 'e la',
        'Privacy policy': 'Privacy',
        'Invalid email': 'Email non valida',
        'Address': 'Indirizzo',
        'City': 'Città',
        'Postal code': 'CAP',
        'Phone': 'Telefono',
    },
    es: {
        'Language': 'Idioma',
        'English': 'Inglés',
        'Italian': 'Italiano',
        'Spanish': 'Español',
        'Dashboard': 'Panel',
        'Tokens': 'Tokens',
        'Invoices': 'Facturas',
        'Product creation': 'Creación de producto',
        'Navigation Menu': 'Menú de navegación',
        'Sidebar': 'Barra lateral',
        'Displays the mobile sidebar.': 'Muestra la barra lateral móvil.',
        'Toggle Sidebar': 'Alternar barra lateral',
        'More': 'Más',
        'Search': 'Buscar',
        'Platform': 'Plataforma',
        'Settings': 'Configuración',
        'Log out': 'Cerrar sesión',
        'Profile': 'Perfil',
        'Password': 'Contraseña',
        'Two-Factor Auth': 'Autenticación de dos factores',
        'Appearance': 'Apariencia',
        'Manage your profile and account settings':
            'Administra tu perfil y configuración de cuenta',
        'Profile settings': 'Configuración de perfil',
        'Profile information': 'Información de perfil',
        'Update your name and email address':
            'Actualiza tu nombre y dirección de correo',
        'Name': 'Nombre',
        'Full name': 'Nombre completo',
        'Email address': 'Dirección de correo',
        'Your email address is unverified.':
            'Tu dirección de correo no está verificada.',
        'Click here to resend the verification email.':
            'Haz clic aquí para reenviar el correo de verificación.',
        'A new verification link has been sent to your email address.':
            'Se ha enviado un nuevo enlace de verificación a tu correo.',
        'Save': 'Guardar',
        'Saved': 'Guardado',
        'Delete account': 'Eliminar cuenta',
        'Delete your account and all of its resources':
            'Elimina tu cuenta y todos sus recursos',
        'Warning': 'Advertencia',
        'Please proceed with caution, this cannot be undone.':
            'Procede con precaución, esto no se puede deshacer.',
        'Are you sure you want to delete your account?':
            '¿Seguro que deseas eliminar tu cuenta?',
        'Once your account is deleted, all of its resources and data will also be permanently deleted. Please enter your password to confirm you would like to permanently delete your account.':
            'Una vez eliminada la cuenta, todos los recursos y datos se borrarán permanentemente. Ingresa tu contraseña para confirmar.',
        'Cancel': 'Cancelar',
        'Password settings': 'Configuración de contraseña',
        'Update password': 'Actualizar contraseña',
        'Ensure your account is using a long, random password to stay secure':
            'Asegúrate de usar una contraseña larga y aleatoria',
        'Current password': 'Contraseña actual',
        'New password': 'Nueva contraseña',
        'Confirm password': 'Confirmar contraseña',
        'Save password': 'Guardar contraseña',
        'Appearance settings': 'Configuración de apariencia',
        "Update your account's appearance settings":
            'Actualiza la apariencia de tu cuenta',
        'Light': 'Claro',
        'Dark': 'Oscuro',
        'System': 'Sistema',
        'Toggle theme': 'Cambiar tema',
        'Two-Factor Authentication': 'Autenticación de dos factores',
        'Manage your two-factor authentication settings':
            'Administra la configuración de autenticación de dos factores',
        'Enabled': 'Activada',
        'Disabled': 'Desactivada',
        'With two-factor authentication enabled, you will be prompted for a secure, random pin during login, which you can retrieve from the TOTP-supported application on your phone.':
            'Con la autenticación de dos factores activada, se te pedirá un PIN seguro durante el inicio de sesión, que puedes obtener en tu app TOTP.',
        'Disable 2FA': 'Desactivar 2FA',
        'When you enable two-factor authentication, you will be prompted for a secure pin during login. This pin can be retrieved from a TOTP-supported application on your phone.':
            'Al activar la autenticación de dos factores, se te pedirá un PIN seguro en el inicio de sesión. Puedes obtenerlo en una app TOTP.',
        'Continue Setup': 'Continuar configuración',
        'Enable 2FA': 'Activar 2FA',
        '2FA Recovery Codes': 'Códigos de recuperación 2FA',
        'Recovery codes let you regain access if you lose your 2FA device. Store them in a secure password manager.':
            'Los códigos de recuperación te ayudan si pierdes tu dispositivo 2FA. Guárdalos en un gestor seguro.',
        'Hide': 'Ocultar',
        'View': 'Ver',
        'Recovery Codes': 'Códigos de recuperación',
        'Regenerate Codes': 'Regenerar códigos',
        'Recovery codes': 'Códigos de recuperación',
        'Loading recovery codes': 'Cargando códigos de recuperación',
        'Each recovery code can be used once to access your account and will be removed after use. If you need more, click {action} above.':
            'Cada código de recuperación se puede usar una sola vez y se eliminará tras usarlo. Si necesitas más, haz clic en {action} arriba.',
        'Something went wrong.': 'Algo salió mal.',
        'Token balance': 'Saldo de tokens',
        'Purchase tokens once and use them across any feature you need.':
            'Compra tokens una vez y úsalos en cualquier función.',
        'Available tokens': 'Tokens disponibles',
        'Spend tokens wherever you need them across the app.':
            'Usa tokens donde los necesites en la app.',
        'Payment canceled': 'Pago cancelado',
        'Success': 'Éxito',
        '{count} tokens': '{count} tokens',
        '/ pack': '/ paquete',
        'Tokens are universal and can be spent on any feature—image generation, text polishing, or future creative tools. You can purchase multiple packs at checkout.':
            'Los tokens son universales y pueden usarse en cualquier función: generación de imágenes, pulido de texto o herramientas futuras. Puedes comprar varios paquetes en el checkout.',
        'Billing currency: {currency}': 'Moneda de facturación: {currency}',
        'Pack quantity': 'Cantidad de paquetes',
        'Starting checkout...': 'Iniciando checkout...',
        'Buy tokens': 'Comprar tokens',
        'Configure price ID': 'Configurar ID de precio',
        'Invoice history': 'Historial de facturas',
        'Your most recent Stripe invoices and receipts.':
            'Tus facturas y recibos más recientes de Stripe.',
        'Review and download receipts for your token purchases.':
            'Revisa y descarga recibos de tus compras de tokens.',
        '{count} total': '{count} total',
        'No invoices found yet. Purchases will appear here once completed.':
            'Aún no hay facturas. Las compras aparecerán aquí al completarse.',
        'Invoice #{number}': 'Factura n.º {number}',
        'paid': 'pagada',
        'open': 'abierta',
        'draft': 'borrador',
        'View invoice': 'Ver factura',
        'Log in to your account': 'Accede a tu cuenta',
        'Enter your email and password below to log in':
            'Introduce tu correo y contraseña para acceder',
        'Log in': 'Iniciar sesión',
        'Forgot password?': '¿Olvidaste tu contraseña?',
        'Forgot password': '¿Olvidaste tu contraseña?',
        'Enter your email to receive a password reset link':
            'Ingresa tu correo para recibir un enlace de restablecimiento',
        'Remember me': 'Recuérdame',
        "Don't have an account?": '¿No tienes una cuenta?',
        'Sign up': 'Regístrate',
        'Create an account': 'Crea una cuenta',
        'Enter your details below to create your account':
            'Introduce tus datos para crear una cuenta',
        'Already have an account?': '¿Ya tienes una cuenta?',
        'Register': 'Registrarse',
        'Forgot your password?': '¿Olvidaste tu contraseña?',
        'No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.':
            'No hay problema. Indica tu correo y te enviaremos un enlace para restablecer la contraseña.',
        'Email password reset link': 'Enviar enlace de restablecimiento',
        'Or, return to': 'O vuelve a',
        'Back to log in': 'Volver a iniciar sesión',
        'Reset password': 'Restablecer contraseña',
        'Please enter your new password below':
            'Ingresa tu nueva contraseña a continuación',
        'Confirm your password': 'Confirma tu contraseña',
        'This is a secure area of the application. Please confirm your password before continuing.':
            'Esta es un área segura de la aplicación. Confirma tu contraseña para continuar.',
        'Confirm': 'Confirmar',
        'Continue': 'Continuar',
        'Authentication Code': 'Código de autenticación',
        'or you can': 'o puedes',
        'or, enter the code manually': 'o ingresa el código manualmente',
        'Back': 'Atrás',
        'Close': 'Cerrar',
        'Two-Factor Authentication Enabled':
            'Autenticación de dos factores activada',
        'Two-factor authentication is now enabled. Scan the QR code or enter the setup key in your authenticator app.':
            'La autenticación de dos factores está activada. Escanea el QR o ingresa la clave en tu app.',
        'Verify Authentication Code': 'Verificar código de autenticación',
        'Enter the 6-digit code from your authenticator app':
            'Ingresa el código de 6 dígitos de tu app de autenticación',
        'Enable Two-Factor Authentication':
            'Activar autenticación de dos factores',
        'To finish enabling two-factor authentication, scan the QR code or enter the setup key in your authenticator app':
            'Para finalizar, escanea el QR o ingresa la clave en tu app.',
        'Two factor challenge': 'Desafío de dos factores',
        'Please confirm access to your account by entering the authentication code provided by your authenticator application.':
            'Confirma el acceso ingresando el código de tu aplicación de autenticación.',
        'Please confirm access to your account by entering one of your emergency recovery codes.':
            'Confirma el acceso ingresando uno de tus códigos de recuperación.',
        'Code': 'Código',
        'Recovery code': 'Código de recuperación',
        'Use a recovery code': 'Usar un código de recuperación',
        'Use an authentication code': 'Usar un código de autenticación',
        'Verify email': 'Verificar correo',
        'Please verify your email address by clicking on the link we just emailed to you.':
            'Verifica tu correo haciendo clic en el enlace que te enviamos.',
        'Thanks for signing up! Before getting started, could you verify your email address by clicking on the link we just emailed to you? If you did not receive the email, we will gladly send you another.':
            '¡Gracias por registrarte! Antes de empezar, verifica tu correo haciendo clic en el enlace que te enviamos. Si no lo recibiste, te enviaremos otro.',
        'A new verification link has been sent to the email address you provided during registration.':
            'Se envió un nuevo enlace de verificación al correo proporcionado.',
        'Resend verification email': 'Reenviar correo de verificación',
        'Welcome': 'Bienvenido',
        "Let's get started": 'Empecemos',
        'Laravel has an incredibly rich ecosystem. We suggest starting with the following.':
            'Laravel tiene un ecosistema muy rico. Sugerimos comenzar con lo siguiente.',
        'Read the': 'Lee la',
        'Documentation': 'Documentación',
        'Watch video tutorials at': 'Mira tutoriales en',
        'Deploy now': 'Desplegar ahora',
        'Modifica il codice EAN o continua':
            'Modifica el código EAN o continúa',
        'Crea la scheda prodotto per il tuo catalogo':
            'Crea la ficha de producto para tu catálogo',
        'EAN': 'EAN',
        'Brand': 'Marca',
        'Prodotto salvato': 'Producto guardado',
        'Il prodotto è stato salvato nelle bozze del tuo catalogo.':
            'El producto se guardó en los borradores del catálogo.',
        'Inserisci codice EAN (13 cifre)':
            'Introduce el código EAN (13 dígitos)',
        'Valido': 'Válido',
        'Non valido': 'No válido',
        'Nuovo Prodotto': 'Nuevo producto',
        'Nuovo prodotto': 'Nuevo producto',
        'Verifica in corso...': 'Verificando...',
        'Verifica GS1': 'Verificar GS1',
        'Continua': 'Continuar',
        'Inserisci il codice EAN a 13 cifre del prodotto per verificarne la validità':
            'Introduce el código EAN de 13 dígitos para verificar su validez',
        'Chiudi': 'Cerrar',
        'Salvare questo prodotto?': '¿Guardar este producto?',
        'Vuoi salvare questo prodotto nel tuo catalogo in bozze per completarlo successivamente o vuoi eliminarlo?':
            '¿Quieres guardar este producto como borrador para terminarlo después o eliminarlo?',
        'Salva in Bozze': 'Guardar como borrador',
        'Elimina Prodotto': 'Eliminar producto',
        'EAN:': 'EAN:',
        "Qual'è il brand del prodotto?": '¿Cuál es la marca del producto?',
        'Inserisci il nome del marchio': 'Ingresa el nombre de la marca',
        'Es. Apple, Samsung, Nike...': 'Ej. Apple, Samsung, Nike...',
        'Nota bene:': 'Nota:',
        'scrivere come visibile sulla confezione o, se presente, nella registrazione ufficiale del marchio, rispettando maiuscole e minuscole.':
            'escríbelo como aparece en el empaque o en el registro oficial de la marca, respetando mayúsculas y minúsculas.',
        'Indietro': 'Atrás',
        'Step {current} di {total}': 'Paso {current} de {total}',
        'Immagine': 'Imagen',
        'Titolo': 'Título',
        'Tipologia': 'Tipo',
        'Categoria': 'Categoría',
        'Contenuti': 'Contenido',
        'Dimensioni': 'Dimensiones',
        'Prezzo/Stock/T.c.': 'Precio/Stock/Plazo',
        'Info Generali': 'Información general',
        'Immagini': 'Imágenes',
        'First name': 'Nombre',
        'Last name': 'Apellido',
        'User info': 'Información del usuario',
        'Company info': 'Información de la empresa',
        'Company name': 'Nombre de la empresa',
        'VAT ID': 'NIF',
        'Admin name': 'Nombre del administrador',
        'Province': 'Provincia',
        'Country': 'País',
        'Company email': 'Correo de la empresa',
        'Create password': 'Crear contraseña',
        'Password strength: weak': 'Seguridad: débil',
        'Password strength: medium': 'Seguridad: media',
        'Password strength: strong': 'Seguridad: fuerte',
        'At least 8 characters': 'Al menos 8 caracteres',
        'At least one uppercase': 'Al menos una mayúscula',
        'At least one lowercase': 'Al menos una minúscula',
        'At least one number': 'Al menos un número',
        'At least one special char': 'Al menos un carácter especial',
        'Passwords match': 'Las contraseñas coinciden',
        'I accept': 'Acepto',
        'Terms and conditions': 'Términos y condiciones',
        'and the': 'y la',
        'Privacy policy': 'Política de privacidad',
        'Invalid email': 'Correo inválido',
        'Address': 'Dirección',
        'City': 'Ciudad',
        'Postal code': 'Código postal',
        'Phone': 'Teléfono',
    },
} as const;

export const supportedLanguages = ['en', 'it', 'es'] as const;
export type Language = (typeof supportedLanguages)[number];

export const languageLabels: Record<Language, string> = {
    en: 'English',
    it: 'Italian',
    es: 'Spanish',
};
